import script from "./MobileTreated.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileTreated.vue?vue&type=script&lang=ts&setup=true"

import "./MobileTreated.vue?vue&type=style&index=0&id=3405d2a7&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3405d2a7"]])

export default __exports__